/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import datasetTypes from '../../enums/datasetTypes';
import GenericChartVisualization from './chart/GenericChartVisualization';
import genericChartVisualizationStaticPropertiesReducer from './chart/reducers/genericChartVisualizationReducer';

export class AreaVisualization extends GenericChartVisualization {
    getChartSection() {
        const chart = super.getChartSection();

        return {
            ...chart,
            type: 'area'
        };
    }

    getXAxisSection(selectedRowIndex: number) {
        const section = super.getXAxisSection(selectedRowIndex);

        return {
            ...section,
            categories: this.getCategoriesTree(selectedRowIndex)
        }
    }
}

export const AreaVisualizationDescriptor = {
    legacyAdhoc: 'area',
    cssClass: 'Area',
    bundleName: 'adhoc.visualisation.chooser.type.AREA',
    name: 'Area',
    group: 'adhoc.visualisation.chooser.type.GROUP_LINE_AND_AREA',
    datasetType: datasetTypes.MULTI_AXIS,
    component: AreaVisualization,
    staticPropertiesReducer: genericChartVisualizationStaticPropertiesReducer,
    requirements: {
        measures: { min: 1 },
        fields: { min: 0 }
    }
};
